<template>
<PageLayout :screenWidth="windowWidth" :loaded="meta.loaded">
   <section class="app-section app-section-light-grey container-fluid">
     <section class="container" id="edit-column-width">
       <!-- <b-col sm="12" class="mb-4">
          <b-button v-if="!editButton" @click="editButton = !editButton" size=sm class="float-right" variant="outline-warning" id="edit-button">View Honeymoon Guestcard Example</b-button>
          <b-button v-if="editButton" @click="editButton = !editButton" size=sm class="float-right" variant="outline-warning" id="edit-button">View Celebration Guestcard Example</b-button>
        </b-col> -->
     </section>
       <section class="container">
            <!-- <b-row align-content="center"> -->
                <b-col sm=12>

                    <b-row v-if="typeHoneymoon" align-content="center">
                        <b-col sm="1"></b-col>
                        <b-col sm="10">
                        <h1 class="section-heading">Example Guest Card</h1>
                        <p class="text-center mb-5">We'll provide you with stylish guest cards (dimensions 15cm depth x 10.5cm width) that you can use to let everyone know your preference for the 'gift of travel'.</p>
                        <div>
                            <b-img center fluid src="https://www.trailfinders.com/graphics/weddings/card1.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                        </div>
                            <hr class="hr-02">
                            <h3 class="text-center">Reverse</h3>
                        <div>
                            <b-img v-if="!isIe" fluid center src="https://www.trailfinders.com/graphics/weddings/cardrear.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                            <b-img v-if="isIe" fluid center src="https://www.trailfinders.com/graphics/weddings/cardrearIE.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                        </div>
                        </b-col>
                    </b-row>

                    <b-row v-if="!typeHoneymoon" align-content="center">
                        <b-col sm="1"></b-col>
                        <b-col sm="10">
                        <h1 class="section-heading">Example Guest Card</h1>
                        <p class="text-center mb-5">We'll provide you with stylish guest cards (dimensions 15cm depth x 10.5cm width) that you can use to let everyone know your preference for the 'gift of travel'.</p>
                        <div>
                            <b-img fluid center src="https://www.trailfinders.com/graphics/giftlist/card_front.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                        </div>
                            <hr class="hr-02">
                            <h3 class="text-center">Reverse</h3>
                        <div>
                            <b-img v-if="!isIe" fluid center src="https://www.trailfinders.com/graphics/giftlist/card_back.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                            <b-img v-if="isIe" fluid center src="https://www.trailfinders.com/graphics/giftlist/card_backIE.jpg" style="margin-bottom: 2%; border: 1px solid silver"></b-img>
                        </div>
                        </b-col>
                    </b-row>

                    

                </b-col>
            <!-- </b-row> -->
        </section>
        <hr class="hr-02"/>  
    </section>
</PageLayout >
</template>

<script>


export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      typeHoneymoon: null,
      editButton: false,
      date: null,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      isIe: false,
    };
  },
    beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  mounted() {
    if (this.$route.params.wishlistType === 'honeymoon') {
      this.typeHoneymoon = true
    } else {
      this.typeHoneymoon = false
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize());
    })
      if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.isIe = true
      

    } else {
      this.isIe = false
     
    }
    this.meta.loaded = true;
    this.date = Date.now();
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
      if (window.innerWidth < 790) {
        this.vertical = true
      } else {
        this.vertical = false
      }
    }
  }
};
</script>
